import { ControlledMaterialUpdateType } from '@ukpostbox/client-data';
import { FlexGap, StackVertical, Surface } from '@ukpostbox/frontend-framework';
import { FormProvider, useFieldArray, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect } from 'react';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { BatchYesNo } from '../Controls/BatchYesNo';

function BatchContentsDeclaration(props: RenderBatchSectionType) {
	const { currentBatchData, declarationUpdating, UpdateLithiumBatteries, UpdateControlledMaterials } =
		useForwardingBatchProvider();

	const formMethods = useForm({
		defaultValues: {
			controlledMaterials: currentBatchData?.controlledMaterials,
		},
		mode: 'onChange',
	});

	const { fields, append } = useFieldArray({
		control: formMethods.control,
		name: `controlledMaterials`,
		shouldUnregister: true,
	});
	const UpdateControlledMaterial = (controlledMaterial: any, data: ControlledMaterialUpdateType) => {
		if (controlledMaterial.description === 'Lithium batteries') {
			UpdateLithiumBatteries(data.declared);
		}

		UpdateControlledMaterials(controlledMaterial.id, data);
	};

	const MapDescriptionsToFields = (data: any) => {
		data.forEach((controlledMaterial: any) => append(controlledMaterial));
	};

	useEffect(() => {
		if (currentBatchData?.controlledMaterials && fields.length === 0) {
			MapDescriptionsToFields(currentBatchData?.controlledMaterials);
		}
	}, []);

	return (
		<FormProvider {...formMethods}>
			<div>
				<h5 className='mb-xs'>
					{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}
				</h5>
				{!props.complete && (
					<p>
						In the interest of safety to both UK Postbox And postal/courier staff, please tell us if your
						package/s contains any of the following. This information will also be used to ensure compliance
						with national, and international, transport regulations in relation to prohibited and dangerous
						goods.
					</p>
				)}

				<Surface extraClass={`p-md ${!formMethods.formState.isValid ? 'invalid' : ''}`}>
					<StackVertical gap={FlexGap.Medium}>
						{currentBatchData?.controlledMaterials.map((controllerMaterial, index) => {
							if (props.complete && !controllerMaterial.declared) {
								return null;
							}

							return (
								<BatchYesNo
									id={controllerMaterial.id}
									key={`conmat_${controllerMaterial.id}`}
									index={index}
									label={controllerMaterial.description}
									groupName={controllerMaterial.description}
									isChecked={controllerMaterial.declared}
									notes={controllerMaterial.notes}
									readOnly={declarationUpdating || props.readOnly || props.complete}
									onChange={(e: any) => {
										UpdateControlledMaterial(controllerMaterial, {
											declared: e.checked,
											notes: e.notes,
										});
									}}
								/>
							);
						})}
					</StackVertical>
				</Surface>
			</div>
		</FormProvider>
	);
}

export { BatchContentsDeclaration };
